import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUserSecret,faUser, faToolbox, faUserCog,faStarHalfAlt,faColumns,faComments,faPlus,faTrashAlt,
        faDollarSign,faPause,faTimes,faStar,faSearch, faEye, faCheck, faPlay, faCreditCard, faEllipsisV , faArchive,
        faFileInvoiceDollar,faEdit,faSave, faFilePdf, faFileWord, faFile, faIdCard,faArrowCircleLeft, faPrint, faArrowsAltV,
        faQuestionCircle,faSortDown,faSortUp, faHandshake, faChartLine, faDonate, faBlog, faBell, faExclamationTriangle} from '@fortawesome/free-solid-svg-icons';

library.add(faUserSecret,faUser,faToolbox,faUserCog,faStarHalfAlt,faColumns,faComments,faPlus,faTrashAlt,
        faDollarSign,faPause,faTimes,faStar,faSearch,faEye,faCheck,faPlay, faCreditCard, faEllipsisV , 
        faArchive,faFileInvoiceDollar,faEdit,faSave,faFilePdf,faFileWord,faFile,faIdCard,faArrowCircleLeft,faPrint,
        faArrowsAltV,faQuestionCircle,faSortDown,faSortUp,faHandshake,faChartLine,faDonate,faBlog,faBell, faExclamationTriangle);

Vue.component('font-icon', FontAwesomeIcon)



// WEBPACK FOOTER //
// ./src/icons.js